module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbar",
    class: {
      'in-electron': _vm.electron
    }
  }, [_c('div', {
    staticClass: "tabbar-tab-container"
  }, _vm._l((_vm.tabsInStage), function(tab) {
    return _c('Tab', {
      key: tab.id,
      class: {
        'in-electron': _vm.electron
      },
      attrs: {
        "tab": tab,
        "isFixedWidth": _vm.mode === 'panel',
        "tabWidth": _vm.tabWidth,
        "activeId": _vm.activeId,
        "hasTabMoving": _vm.hasTabMoving
      },
      on: {
        "tab-activate": _vm.activateTab,
        "tab-destroy": _vm.destroyTab,
        "tab-dragstart": _vm.onTabDragstart,
        "tab-drag": _vm.onTabDrag,
        "tab-dragend": _vm.onTabDragend
      }
    })
  })), _vm._v(" "), (_vm.mode === 'right' ? true : (_vm.tabsInStore.length ? true : false)) ? _c('span', {
    staticClass: "tabbar-store-button tofu-icon icon-more",
    class: {
      'store-button-active': _vm.showStore
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStore($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStore),
      expression: "showStore"
    }],
    staticClass: "tab-store",
    on: {
      "click": _vm.toggleStore
    }
  }, _vm._l((_vm.tabsInStore), function(tab) {
    return _c('TabStoreItem', {
      key: tab.id,
      attrs: {
        "tab": tab,
        "activeId": _vm.activeId
      },
      on: {
        "store-activate": _vm.activateTab,
        "store-destroy": _vm.destroyTab
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-76fa8fa0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/new-tabbar/src/tabbar.vue
// module id = 668
// module chunks = 0